import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/show_export_quality_inspect/${agro_exporter_id}/crop_field`
    );
  },
  fetchCropField(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_templates/${agro_exporter_id}/crop_field/${crop_field_id}`
    );
  },
  fetchExportQualityGroups(agro_exporter_id, quality_template_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/show_export_quality_inspect/${agro_exporter_id}/list_quality_groups/${quality_template_id}`
    );
  },
  destroyExportQualityInspect(agro_exporter_id, quality_inspect_id) {
    return RequesterV1.delete(
      `agro_exporter/quality_control/crop_field/show_export_quality_inspect/${agro_exporter_id}/${quality_inspect_id}`
    );
  },
  fetchTemplate({ agro_exporter_id, crop_field_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/show_export_quality_inspect/${agro_exporter_id}/crop_field/${crop_field_id}/quality_template/${quality_template_id}`
    );
  },
  getExportQualityInspect(agro_exporter_id, quality_inspect_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/show_export_quality_inspect/${agro_exporter_id}/${quality_inspect_id}`
    );
  }
};
